const triggerRegisterGWPApi = (sessionId, email, password,name,termsCondition,optOutMarketing) => {
    const body = {
        "external_reference_no": "1",
        "security": {
            "session": {
                "id": sessionId
            },
            "client_ip": "003217201105",
            "version": "1"
        },
        "analytics": {
            "state": null,
            "analytic_event": [
                {
                    "fields": {
                        "field": [
                            {
                                "name": "registrationPersonalTime",
                                "value": "60"
                            },
                            {
                                "name": "registrationSecurityTime",
                                "value": "60"
                            },
                            {
                                "name": "registrationTime",
                                "value": "0"
                            },
                            {
                                "name": "invalidEmailCount",
                                "value": "3"
                            },
                            {
                                "name": "registrationErrorList",
                                "value": ""
                            },
                            {
                                "name": "infoRegUserName",
                                "value": email
                            },
                            {
                                "name": "infoSecQ1",
                                "value": ""
                            }
                        ]
                    }
                }
            ]
        },
        "gateway_customer": {
            email,
            "name": name,
            "identities": {
                "identity": [
                    {
                        "data": password,
                        "type": "PASSWORD"
                    }
                ]
            },
            "terms_condition_flag": termsCondition,
            "account_preferences": {
                "direct_mail": false,
                "email": true,
                "telephone_call": false,
                "message": false,
                "opt_out_marketing": optOutMarketing,
                "thirdparty_datasharing_consent": true
            }
        },
        "progressive_registration": "true"
    }

    const requestOptions = {
        method: "POST",
        headers: {
            "accept": "application/json, text/plain, */*",
            "Content-Type": "application/json",
            "accept-language": "en-US,en;q=0.9"
        },
        body: JSON.stringify(body)
    };

    return fetchApiWu(`/wudgtsrvs/mobiliser/rest/channel/v2.0/GwpRegisterCustomer?timestamp=${new Date().getTime()}`, requestOptions, "GwpRegisterCustomer");
  }